const state = {

};

const getters = {

};


const actions = {
    async getProperties({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/tenants/properties`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getProperty({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/tenants/properties/${params.property_id}`, {
                    params: {
                        parent_id: params.parent_id,
                        is_load_contract: params.is_load_contract || false
                    }
                }).then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async raiseCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("property_id", params.property_id);
            formData.append("location_id", params.location_id);
            formData.append("nature_feedback_id", params.nature_feedback_id);
            //formData.append("nature_of_feedback", params.nature_of_feedback );
            formData.append("feedback_detail", params.feedback_detail);
            formData.append("requestor", JSON.stringify(params.requestor));
            formData.append("service_category_id", params.service_category_id);
            if (params.attachments) {
                for (var i = 0; i < params.attachments.length; i++) {
                    let photo = params.attachments[i];
                    formData.append('attachments[' + i + ']', photo);
                }
            }

            global.axios.post(`api/tenants/raise-case`, formData)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },

}

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}